import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const MediaEntertainment = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Solutions / Media & Entertainment</h6>
          <hr />
          <h1 className="banner-title">
            Revolutionize Media & Entertainment <br /> with Advanced Software
            Solutions
          </h1>

          <p>
            Enhance content creation, distribution, and audience engagement with
            innovative software solutions.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/couple-using-computer-mixing-mastering-music_23-2148366479.jpg"
          alt="Media & Entertainment Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6 className="col_yell text-center">Media & Entertainment</h6>
              <h2 className="text-center">
                Empowering the Media Industry with Cutting-Edge Software
                Solutions
              </h2>
              <p className="text-center">
                Our software solutions are designed to help media and
                entertainment businesses improve their workflow, streamline
                content production, enhance audience engagement, and increase
                revenue.
              </p>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Media & Entertainment Solutions</h2>
              <p className="text-center mb-0">
                Transform content creation, distribution, and audience
                engagement with tailored software solutions.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Content Creation and Management</a>
              </h3>
              <p className="mb-4">
                Simplify content creation, organization, and distribution to
                deliver better experiences to your audience.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Digital Rights Management</a>
              </h3>
              <p className="mb-4">
                Protect your digital content from piracy and unauthorized usage
                with advanced rights management systems.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Audience Engagement Analytics</a>
              </h3>
              <p className="mb-4">
                Analyze audience behavior and preferences to deliver
                personalized content and improve user engagement.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Monetization & Distribution</a>
              </h3>
              <p className="mb-4">
                Maximize revenue through effective content monetization
                strategies and efficient distribution platforms.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2>Ready to Elevate Your Media & Entertainment Business?</h2>
                <p className="mt-3">
                  Discover how our software solutions can enhance your content
                  creation, distribution, and audience engagement.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MediaEntertainment;
